<template>
  <main class="text-center text-white relative z-20 pt-6 md:pt-0" id="contact">
    <Teleport to="body">
      <NoticeView v-if="open" @close="open = false" />
    </Teleport>
    <Teleport to="body">
      <div
        v-if="showValidationError"
        class="fixed w-full h-full inset-0 bg-black/80 flex justify-center items-center"
        style="z-index: 99999"
        @click.self="showValidationError = false"
      >
        <div
          class="bg-[#f8e1e2] w-full max-w-lg m-8 rounded-lg shadow-lg relative"
        >
          <button
            @click="showValidationError = false"
            class="absolute top-4 right-4 text-[#a72a2e] hover:text-[#8a2226] !bg-transparent !shadow-none !w-8 !h-8 !p-0 !min-w-0"
            aria-label="Fermer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <div class="p-8">
            <div class="flex items-center mb-4">
              <div
                class="w-12 h-12 rounded-full bg-[#a72a2e] flex items-center justify-center mr-4 flex-shrink-0"
              >
                <span class="text-white text-2xl font-bold">!</span>
              </div>
              <h2 class="text-[#a72a2e] text-2xl font-veneer font-bold">
                Erreurs de validation
              </h2>
            </div>
            <p class="text-[#a72a2e] mb-4 font-neue">
              Veuillez vérifier les erreurs restantes dans le formulaire.
            </p>
            <div class="text-left">
              <p class="text-[#a72a2e] font-bold mb-2 font-neue">
                Champs concernés :
              </p>
              <ul class="list-none text-[#a72a2e] space-y-1 font-neue">
                <li
                  v-for="field in validationErrors"
                  :key="field"
                  class="flex items-start"
                >
                  <span class="mr-2">•</span>
                  <span>{{ field }}</span>
                </li>
              </ul>
            </div>
            <button
              @click="showValidationError = false"
              class="btn !bg-[#a72a2e] !text-white block m-auto mt-6 font-veneer hover:!bg-[#8a2226]"
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </Teleport>

    <img
      src="../assets/images/pepite1.png"
      class="sm:hidden w-[15vw] absolute top-[45px] -right-[3vw] rotate-[270deg] z-50"
      style="align-items: center"
    />
    <img
      src="../assets/images/pepite2.png"
      class="sm:hidden w-[5vw] absolute top-[165px] left-[3vw] rotate-[20deg] z-50"
      style="align-items: center"
    />

    <img
      src="../assets/images/noisette.png"
      class="sm:hidden w-[10vw] absolute top-[395px] -left-[10px] rotate-[20deg] z-50"
      style="align-items: center"
    />
    <img
      src="../assets/images/noisette.png"
      class="sm:hidden w-[10vw] absolute bottom-[15px] right-[20px] rotate-[20deg] z-50"
      style="align-items: center"
    />
    <img
      src="../assets/images/pepite2.png"
      class="sm:hidden w-[4vw] absolute -bottom-[20px] right-[15px] rotate-[20deg] z-50"
      style="align-items: center"
    />
    <Teleport to="body">
      <div
        v-if="send"
        class="fixed w-full h-full inset-0 bg-black/80 flex justify-center items-center"
        style="z-index: 99999"
      >
        <div
          class="bg-[#df0919] w-full max-w-xl m-8 rounded p-8 shadow-lg font-neue text-lg text-white"
        >
          <h1 class="font-veneer text-3xl text-white w-full text-center mb-4">
            Email envoyé !
          </h1>
          <p>
            Un email contenant un lien vous permettant de participer plus tard
            vient de vous être envoyé à {{ form.email }}.
          </p>
          <p>
            <router-link to="/"
              ><span class="btn block m-auto mt-6 font-veneer"
                >Fermer</span
              ></router-link
            >
          </p>
        </div>
      </div>
    </Teleport>
    <div
      class="ombre2 top-48 opacity-40 left-1/2 -translate-x-1/2 -translate-y-1/2 absolute aspect-square max-w-4xl w-full m-auto z-30"
    ></div>
    <div class="relative z-40">
      <h1
        class="text-white text-[6vw] leading-[7vw] sm:text-3xl font-veneer mb-6 mt-8"
      >
        Vous n’avez pas encore acheté<br />deux produits participants ?*
      </h1>

      <p
        class="text-white text-[4vw] leading-[5vw] sm:text-xl font-veneer mb-6"
      >
        Ne vous inquiétez pas, en remplissant le
        <br class="md:hidden" />formulaire ci-dessous vous recevrez un email<br />pour
        compléter votre inscription et télécharger <br class="md:hidden" />votre
        ticket de caisse ultérieurement.
      </p>
      <form @submit.prevent="getResult" class="px-[12vw] sm:px-8">
        <div v-if="!code" class="form-item">
          <input
            @input="error.code = ''"
            @blur="touched.code = true"
            :disabled="loadingState"
            v-model="form.code"
            type="text"
            placeholder="Veuillez indiquer le code unique**"
          />
          <span v-if="error.code" class="error">{{ error.code }}</span>
        </div>
        <div class="form-item">
          <input
            @input="error.lastname = ''"
            @blur="touched.lastname = true"
            :disabled="loadingState"
            v-model="form.lastname"
            id="lastname"
            type="text"
            placeholder="Nom**"
          />
          <span v-if="error.lastname" class="error">{{ error.lastname }}</span>
        </div>
        <div class="form-item">
          <input
            @input="error.firstname = ''"
            @blur="touched.firstname = true"
            :disabled="loadingState"
            v-model="form.firstname"
            id="firstname"
            type="text"
            placeholder="Prénom**"
          />
          <span v-if="error.firstname" class="error">{{ error.firstname }}</span>
        </div>
        <div class="form-item">
          <input
            @input="error.email = ''"
            @blur="touched.email = true"
            :disabled="loadingState"
            v-model="form.email"
            class="w-full"
            id="email"
            type="text"
            placeholder="Adresse email**"
          />
          <span v-if="error.email" class="error">{{ error.email }}</span>
        </div>

        <div
          class="text-sm text-justify mt-4 flex flex-col justify-start items-start"
        >
          <div class="flex justify-start items-baseline">
            <input
              type="checkbox"
              name="confirm"
              v-model="form.valid"
              @change="error.valid = ''"
              @blur="touched.valid = true"
              class="mr-1"
              id="confirm"
            /><label class="cursor-pointer" for="confirm"
              >J'accepte le traitement de mes données personnelles uniquement dans
              le cadre de la gestion du jeu, conformément à la
              <a
                href="https://oxoformdocs.fra1.digitaloceanspaces.com/696669f88644bf8a91004635/politique.pdf"
                target="_blank"
                class="underline"
                >politique de confidentialité.</a
              >**</label
            >
          </div>
          <span v-if="error.valid" class="error">{{ error.valid }}</span>
        </div>
        <div class="w-full text-center pt-6">
          <button
            v-if="!loadingState"
            type="submit"
            class="btn block m-auto my-6 font-veneer !px-16"
            >Je participe plus tard !</button
          >
          <button
            v-if="loadingState"
            type="button"
            disabled
            class="btn block !bg-gray-100 !text-gray-500 m-auto my-6 font-veneer !px-16"
            >Chargement...</button
          >
        </div>
      </form>
      <p
        class="!font-neue text-sm italic w-full max-w-3xl text-left mx-auto mt-16 px-[12vw] sm:px-4"
      >
        *Produits participants : Kinder<sup>&reg;</sup> Joy x3, Kinder<sup
          >&reg;</sup
        >
        Bueno White x6, Kinder<sup>&reg;</sup> Maxi x20, Kinder<sup>&reg;</sup>
        Tronky x5, Kinder<sup>&reg;</sup> Cards x5, Kinder<sup>&reg;</sup> Crunchy
        cookies x8, Nutella<sup>&reg;</sup> Bready x6
        <br />
        **Champs obligatoires
      </p>

      <p
        class="!font-neue text-sm my-8 w-full max-w-3xl text-left px-[12vw] sm:px-4 mx-auto"
      >
        Ferrero France commerciale traite les données recueillies sur la base de
        votre consentement pour gérer votre participation à ce jeu. Pour en
        savoir plus sur la gestion de vos données personnelles et pour exercer
        vos droits, reportez-vous à la
        <a @click="open = true" class="underline cursor-pointer"
          >notice ci-jointe</a
        >.
      </p>

      <img
        src="../assets/images/caddie-min.png"
        class="sm:hidden w-[45vw] -mb-4 -mt-4"
      />
    </div>
  </main>
</template>

<script>
import axios from "axios";
import Teleport from "vue2-teleport";
import NoticeView from "@/components/NoticeView.vue";
export default {
  data: function () {
    return {
      code: undefined,
      open: false,
      send: false,
      error: {},
      touched: {},
      loadingState: false,
      required_field: ["lastname", "firstname", "email"],
      operationId: "696669f88644bf8a91004635",
      idgame: "2025-Agence TMS-292",
      subid: "",
      uid: "",
      done: false,
      showValidationError: false,
      validationErrors: [],
      form: {
        operation: undefined,
        addr: {},
        valid: false,
      },
    };
  },
  components: {
    Teleport,
    NoticeView,
  },
  async mounted() {
    try {
      console.log(window.code);
      if (window.code) {
        this.code = window.code;
      }

      this.operationId = "696669f88644bf8a91004635";
      this.idgame = "2025-Agence TMS-292";
      this.scrollToTop();
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    isRequired(value) {
      return value ? true : "Ce champ est requis";
    },
    validateForm() {
      this.validationErrors = [];
      this.error = {};

      // Valider le code unique si nécessaire
      if (!this.code && !this.form.code) {
        this.error.code = "Ce champ est requis";
        this.validationErrors.push("Veuillez indiquer le code unique");
      }

      // Valider le nom
      if (!this.form.lastname || this.form.lastname.trim() === "") {
        this.error.lastname = "Ce champ est requis";
        this.validationErrors.push("Nom");
      }

      // Valider le prénom
      if (!this.form.firstname || this.form.firstname.trim() === "") {
        this.error.firstname = "Ce champ est requis";
        this.validationErrors.push("Prénom");
      }

      // Valider l'email
      if (!this.form.email || this.form.email.trim() === "") {
        this.error.email = "Ce champ est requis";
        this.validationErrors.push("Email");
      } else {
        // Vérifier le format de l'email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.form.email)) {
          this.error.email = "Format d'email invalide";
          this.validationErrors.push("Email (format invalide)");
        }
      }

      // Valider la case à cocher
      if (!this.form.valid) {
        this.error.valid = "Vous devez accepter la politique de confidentialité";
        this.validationErrors.push("J'accepte le traitement de mes données personnelles conformément à la politique de confidentialité, dans le cadre de la gestion du jeu");
      }

      return this.validationErrors.length === 0;
    },
    async getResult() {
      try {
        // Valider le formulaire avant de continuer
        if (!this.validateForm()) {
          this.showValidationError = true;
          return;
        }

        this.loadingState = true;

        if (this.code) {
          this.form.code = this.code;
        }

        const liste = await axios.get(
          `https://api-gabarit.promo.dev/api/operations-custom/ferreropalette-t3/data-list/${this.form.code}`
        );
        if (!liste.data.already) {
          this.error.code = "Code incorrect";
          this.loadingState = false;
          this.validationErrors = ["Code incorrect"];
          this.showValidationError = true;
          return;
        }

        let id = sessionStorage.getItem("_id");

        if (id == null) id = "n/a";

        const cd = window.code || this.form.code || "";

        const formDatas = {
          email: this.form.email,
          code_unique: cd,
          last_name: this.form.lastname,
          first_name: this.form.firstname,
        };

        await axios.post(
          `https://api-gabarit.promo.dev/api/operations-custom/ferreropalette-t3/sendLater`,
          formDatas
        );

        this.send = true;
      } catch (e) {
        console.log(e);
        this.loadingState = false;
      }
    },
  },
};
</script>
<style scoped>
.ombre2 {
  background-image: url("@/assets/images/flou-min.png");
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.error {
  @apply text-yellow-200 w-full text-sm block text-left my-1 p-0;
}
</style>
